import React, { useCallback } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { ReactComponent as ExclamationWarningIcon } from "../../../../Assets/ActionIcons/ExclamationWarningIcon.svg";
import { useOnboardingStore } from "../../../../Store/Onboarding";
import { connectIntegration } from "../../../../Utils/IntegrationUtils";
import { PaymentsIntegrationEnum } from "../../../../Contracts/Integration";

const IntegrationReAuthBanner: React.FC = () => {
  const { user } = useAuth0();
  const { adyenKYCDetails, integrationReAuthRequired, integrationReAuthMessage } = useOnboardingStore();

  const onConnect = useCallback(() => {
    if (adyenKYCDetails?.connected_integration) {
      connectIntegration(adyenKYCDetails.connected_integration, user?.sub);
    }
  }, [adyenKYCDetails?.connected_integration, user?.sub]);

  if (!integrationReAuthRequired) return null;

  const integration = adyenKYCDetails?.connected_integration;
  const defaultMessage =
    integration === PaymentsIntegrationEnum.Xero
      ? "Sync paused. Please reconnect your Xero account."
      : "Sync paused. Please reconnect your QuickBooks account.";

  return (
    <div className="bg-yellow-100 border-yellow-300 border-b p-2 flex items-center justify-center">
      <div className="flex items-center space-x-2">
        <ExclamationWarningIcon className="text-orange-500" />
        <div>{integrationReAuthMessage || defaultMessage}</div>
        <button className="bg-blue-600 text-white px-2 py-1 rounded" onClick={onConnect}>
          Reauthorize now
        </button>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(IntegrationReAuthBanner);
